// Minimal product model viewer support for Shopify themes
// Required for product pages with 3D models
(function() {
  'use strict';
  
  if (!window.ProductModel) {
    window.ProductModel = {
      loadShopifyXR: function() {
        // Shopify XR loading stub
      },
      setupShopifyXR: function() {
        // Setup stub
      }
    };
  }
})();
